export enum SPORTS_MENU {
	Soccer = 1,
	Basketball = 2,
	Football = 3,
	IceHockey = 4,
	Tennis = 5,
	Volleyball = 6,
	Pool = 7,
	Baseball = 8,
	Badminton = 9,
	TableTennis = 18,
	Canoeing = 20,
	Handball = 24,
	Darts = 25,
	Rugby = 26,
	FieldHockey = 28,
	Squash = 30,
	Netball = 32,
	ESports = 43,
	MuayThai = 44,
	BeachVolleyball = 45,
	Kabaddi = 47,
	SepakTakraw = 48,
	Futsal = 49,
	Cricket = 50,
	Finance = 55,
	Lotto = 56,
	AlpineSkiing = 57,
	Bandy = 58,
	Biathlon = 59,
	Curling = 60,
	FigureSkating = 61,
	FreestyleSkiing = 62,
	Luge = 63,
	Skeleton = 64,
	SkiJumping = 65,
	SpeedSkating = 66,
	OtherSports = 99,
	Beter = 112,
	VirtualSteeplechase = 125,
	VirtualHarnessRacing = 126,
	VirtualMotorRacing = 127,
	Betby = 134,
	BetbyESoccer = 116,
	VirtuallySoccer = 147,
	HorseRacing = 151,
	Greyhounds = 152,
	Harness = 153,
	NumberGame = 161,
	LiveCasino = 162,
	Happy5 = 164,
	Bitcoin = 175,
	VirtualDogs = 177,
	VirtualFootballCup = 178,
	VirtualFootbalLeague = 179,
	VirtualSoccer = 180,
	VirtualHorseRacing = 181,
	VirtualGreyhounds = 182,
	VirtualSpeedway = 183,
	VirtualMotorsports = 184,
	VirtualCycling = 185,
	VirtualTennis = 186,
	VirtualCricket = 187,
	VirtualCockFighting = 188,
	YoloPlay = 189,
	VirtualSoccerLeague = 190,
	VirtualSoccerNation = 191,
	VirtualSoccerWorldCup = 192,
	VirtualBasketball = 193,
	VirtualSoccerAsianCup = 194,
	VirtualSoccerBundesliga = 195,
	VirtualSoccerChampionsCup = 196,
	VirtualSoccerEuroCup = 197,
	VirtualHorses = 198,
	SabaBasketball = 993,
	SabaSoccer = 997,
	Outright = 999,
};

export interface HeaderFormat {
	KickoffTime?: string;
	MatchName?: string;
	Match?: string;
	FirstHalfScore?: string;
	FinalScore?: string;
	Status?: string;
	Selection?: string;
	FinalResult?: string;
	Q1?: string;
	Q2?: string;
	Q3?: string;
	Q4?: string;
	OT?: string;
	FirstHalf?: string;
	SecondHalf?: string;
	Final?: string;
	Period1?: string;
	Period2?: string;
	Period3?: string;
	Set1?: string;
	Set2?: string;
	Set3?: string;
	Set4?: string;
	Set5?: string;
	TotalPoints?: string;
	TotalSet?: string;
	P1?: string;
	P2?: string;
	P3?: string;
	P4?: string;
	P5?: string;
	P6?: string;
	P7?: string;
	P8?: string;
	P9?: string;
	Game1?: string;
	Game2?: string;
	Game3?: string;
	Game4?: string;
	Game5?: string;
	Game6?: string;
	Game7?: string;
	TotalGame?: string;
	Runs?: string;
	Hits?: string;
	EI?: string;
	Result?: string;
	Win?: string;
	Place?: string;
	NSW?: string;
	VIC?: string;
	SCR?: string;
	GameType?: string;
	PB?: string;
	Date?: string;
	Price?: string;
	Score?: string;
	CorrectScore?: string;
	BS?: string;
	CB?: string;
	MOME?: string;
	OE?: string;
	S4?: string;
	BSToolTip?: string;
	OEToolTip?: string;
	S4ToolTip?: string;
	MOMEToolTip?: string;
	CBToolTip?: string;
	Total?: string;
	Soccer5?: string;
	Soccer5ToolTip?: string;
	Inns1?: string;
	Inns2?: string;
	FirstNo?: string;
	SecondNo?: string;
	LastNo?: string;
	KickoffSeq?: string;
}